// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { searchWithinStyles } from "@rpsc/Overrides/Widgets/ProductList/ProductListSearchWithin";
import IconSearch from "@rpsc/XDL/Icons/IconSearch";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

searchWithinStyles.wrapper = {
    css: css`
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        overflow: hidden;
    `,
};

searchWithinStyles.searchWrapper = {
    css: css`
        padding: 8px 8px 0;
        ${({ noProducts }: any) =>
            noProducts &&
            css`
                padding-bottom: 8px;
            `}
    `,
};

searchWithinStyles.titleText = {
    size: 12,
    weight: fontConfig.weight.bold,
    color: "common.black",
    lineHeight: "14px",
    css: css`
        margin-bottom: 12px;
        display: inline-block;
    `,
};

searchWithinStyles.searchTextField = {
    iconProps: {
        src: IconSearch,
        color: "primary",
    },
    sizeVariant: "default",
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};

searchWithinStyles.stockedFilterWrapper = {
    css: css`
        margin: 12px 13px 9px;
        padding-top: 12px;
        border-top: 1px solid ${getColor("common.border")};
        &:has(> div:empty) {
            padding: 0;
            border-top: 0;
        }
        ${({ noProducts }: any) =>
            noProducts &&
            css`
                display: none;
            `}
    `,
};

searchWithinStyles.subCategoriesWrapper = {
    css: css`
        border-top: 1px solid ${getColor("common.border")};
        &:has(> div:empty) {
            border-top: 0;
        }
    `,
};
